<template>
 <div class="collection-info-section" :class="{'--open': isOpen}">
   <div class="collection-info-section__head" @click="changeOpen">
     <span class="h5 semibold">Инструкция по сборке</span>
     <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
   </div>
   <div class="collection-info-section__body">
     <div class="product-assembly-instructions">
       <template
         v-for="(document) in documents"
         :key="`document-${document.url}`"
       >
         <div class="document-card">
           <div class="document-card__icon">
             <img src="~/assets/img/svg/common/document.svg" alt=""/>
           </div>
           <div v-html="document.caption" class="document-card__name"/>
           <a
             :href="document.url"
             class="document-card__link"
             target="_blank"
             rel="nofollow noopener noreferrer"
           >Скачать (pdf) </a>
         </div>
       </template>
     </div>
   </div>
 </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

export interface IDocument {
  url: string;
  name: string;
  caption: string | undefined;
}
interface IProps {
  documents: IDocument[]
}

const props = withDefaults(defineProps<IProps>(), {
  documents: () => []
});

const isOpen = ref(true);
const changeOpen = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style lang="scss" scoped>
.product-assembly-instructions {
  display: flex;
  flex-direction: column;
  & > * {
    margin-top: 24px;
    &:first-child {
      margin-top: 0;
    }
  }
}

.document-card {
  display: flex;
  align-items: center;
}
.document-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 37px;
  height: 37px;
  border-radius: 10px;
  margin-right: 16px;
  background-color: #F5F5F5;
}
.document-card__name {
  color: #000;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}
.document-card__link {
  margin-left: auto;
  cursor: pointer;
  transition: all 0.3s;

  color: #989898;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  text-decoration-line: underline;

  &:hover {
    text-decoration-color: transparent;
  }
}
</style>
